var _circle, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 28,
    fill: "#F4F7FE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_219_1638)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.2839 24.3135H20.5576C21.6113 24.3135 22.4734 25.1755 22.4734 26.2292V35.808C22.4734 36.8617 21.6113 37.7238 20.5576 37.7238H20.2839C19.2303 37.7238 18.3682 36.8617 18.3682 35.808V26.2292C18.3682 25.1755 19.2303 24.3135 20.2839 24.3135ZM27.947 18.5662C29.0007 18.5662 29.8627 19.4283 29.8627 20.4819V35.808C29.8627 36.8617 29.0007 37.7238 27.947 37.7238C26.8933 37.7238 26.0312 36.8617 26.0312 35.808V20.4819C26.0312 19.4283 26.8933 18.5662 27.947 18.5662ZM35.61 29.5134C36.6637 29.5134 37.5258 30.3755 37.5258 31.4291V35.808C37.5258 36.8617 36.6637 37.7238 35.61 37.7238C34.5564 37.7238 33.6943 36.8617 33.6943 35.808V31.4291C33.6943 30.3755 34.5564 29.5134 35.61 29.5134Z",
    fill: "#D3B054"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_219_1638"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32.8417,
    height: 32.8417,
    fill: "white",
    transform: "translate(11.5264 11.7241)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChart);
export default __webpack_public_path__ + "static/media/chart.f99d4027f13de3b379f1c270f3fda0ba.svg";
export { ForwardRef as ReactComponent };